import { Route } from '@angular/router';
import { VersionControlDataService } from './services/version-control-data/version-control-data.service';
import { VersionControlListComponent } from './components/version-control-list/version-control-list.component';
import { VersionControlService } from '../api/services/version-control.service';

export default [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'driver',
  },
  {
    path: 'driver',
    title: 'Versiones - Aplicación de conductores',
    providers: [VersionControlDataService, VersionControlService],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full'
      },
      {
        path: 'list',
        component: VersionControlListComponent
      }
    ],
  },
  {
    path: 'client',
    title: 'Versiones - Aplicación de conductores',
    providers: [VersionControlDataService, VersionControlService],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full'
      },
      {
        path: 'list',
        component: VersionControlListComponent
      }
    ],
  },
] as Route[];
